// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design System · Tokens · ERF Public / Customer (light-refined executive) */
.ds-theme-erf-public {
  --color-canvas: #FAFAF7;
  --color-surface: #FFFFFF;
  --color-surface-2: #F3F1EB;
  --color-primary: #B8892B;
  --color-primary-emphasis: #8A6620;
  --color-accent: #0F0F10;
  --color-text: #0F0F10;
  --color-text-muted: #6B665A;
  --color-border: #E5E1D6;
  --color-status-positive: #16A34A;
  --color-status-warning: #D97706;
  --color-status-danger: #DC2626;
  --color-status-info: #2563EB;
  --color-status-superseded: #7C3AED;
  --font-display: "Fraunces", "Playfair Display", Georgia, serif;
  --font-body: "Inter Tight", "Inter", system-ui, sans-serif;
  --font-mono: "JetBrains Mono", "IBM Plex Mono", monospace;
  --radius-sm: 4px;
  --radius: 8px;
  --radius-lg: 12px;
  color-scheme: light;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/tokens/erf-public.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,8DAA8D;EAC9D,0DAA0D;EAC1D,yDAAyD;EACzD,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/* Design System · Tokens · ERF Public / Customer (light-refined executive) */\n.ds-theme-erf-public {\n  --color-canvas: #FAFAF7;\n  --color-surface: #FFFFFF;\n  --color-surface-2: #F3F1EB;\n  --color-primary: #B8892B;\n  --color-primary-emphasis: #8A6620;\n  --color-accent: #0F0F10;\n  --color-text: #0F0F10;\n  --color-text-muted: #6B665A;\n  --color-border: #E5E1D6;\n  --color-status-positive: #16A34A;\n  --color-status-warning: #D97706;\n  --color-status-danger: #DC2626;\n  --color-status-info: #2563EB;\n  --color-status-superseded: #7C3AED;\n  --font-display: \"Fraunces\", \"Playfair Display\", Georgia, serif;\n  --font-body: \"Inter Tight\", \"Inter\", system-ui, sans-serif;\n  --font-mono: \"JetBrains Mono\", \"IBM Plex Mono\", monospace;\n  --radius-sm: 4px;\n  --radius: 8px;\n  --radius-lg: 12px;\n  color-scheme: light;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
